import { makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  card: {
    height: '100%',
    width: '100%',
  },
  cardActionArea: {
    minHeight: 300,
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    width: '100%',
  },
  cardContent: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    width: '100%',
  },
  container: {
    display: 'grid',
    gridTemplateRows: '1fr 1fr',
    alignItems: 'center',
    justifyItems: 'center',
    gap: theme.spacing(2),
    height: '100%',
    width: '100%',
  },
  baseItems: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    gap: theme.spacing(3),
  },
  text: {
    textAlign: 'justify',
  },
  orderedList: {
    marginLeft: theme.spacing(3),
  },
  customGridContainer: {
    display: 'grid',
    gap: theme.spacing(2),
    gridTemplateColumns: '1fr',
    [theme.breakpoints.up('md')]: {
      gridTemplateColumns: 'repeat(2, 1fr)',
    },
    [theme.breakpoints.up('lg')]: {
      gridTemplateColumns: 'repeat(5, 1fr)',
    },
  },
}))

export default styles
